import { getStatus } from '@ms/yammer-data-support';
import { NetworkTopicState } from '@ms/yammer-graphql';

import { EntityStatus, YammerState } from '../../state/types';
import { getExperimentTreatment } from '../experiments/selectors';
import { getSession } from '../session/selectors';

type GetCurrentNetworkTopicsState = (state: YammerState) => NetworkTopicState | undefined;
export const getCurrentNetworkTopicsState: GetCurrentNetworkTopicsState = (state) => {
  const topicSettings = getSession(state).networkTopicSettings;

  const moveTopicSettingsExperimentEnabled = state && getExperimentTreatment(state, 'MoveTopicSettings') === true;

  return moveTopicSettingsExperimentEnabled
    ? topicSettings?.fulfilled?.networkTopicsState
    : getSession(state).network.networkTopicsState;
};

type GetNetworkTopicSettingsStatus = (state: YammerState) => EntityStatus;
export const getNetworkTopicSettingsStatus: GetNetworkTopicSettingsStatus = (state) =>
  getStatus(getSession(state).networkTopicSettings);

type IsCurrentNetworkOfficeTopicsEnabled = (state: YammerState) => boolean;
export const isCurrentNetworkOfficeTopicsEnabled: IsCurrentNetworkOfficeTopicsEnabled = (state) => {
  const topicSettings = getSession(state).networkTopicSettings;
  const moveTopicSettingsExperimentEnabled = state && getExperimentTreatment(state, 'MoveTopicSettings') === true;

  return moveTopicSettingsExperimentEnabled
    ? topicSettings.fulfilled?.isOfficeTopicsEnabled ?? false
    : getSession(state).network.isOfficeTopicsEnabled;
};

type ShouldFetchNetworkTopicSettings = (state: YammerState) => boolean;
export const shouldFetchNetworkTopicSettings: ShouldFetchNetworkTopicSettings = (state) =>
  getNetworkTopicSettingsStatus(state) === 'notRequested';

type IsEngageNetworkTopicsStateEnabled = (state: YammerState) => boolean;
export const isEngageNetworkTopicsStateEnabled: IsEngageNetworkTopicsStateEnabled = (state) => {
  const isAnswersInEngageTopicsEnabled = getExperimentTreatment(state, 'AnswersInEngageTopics') === 'enabled';

  const isEngageNetworkTopicsState = getCurrentNetworkTopicsState(state) === NetworkTopicState.ENGAGE;

  return isAnswersInEngageTopicsEnabled && isEngageNetworkTopicsState;
};
